<template>
	<ul class="c-culture__cultures">
		<li
			v-for="culture in cultures"
			:key="culture.Name"
			class="c-culture__list-item"
		>
			<a
				:href="culture.Url"
				class="c-culture__item"
				:class="{
					'c-culture__item--active': culture.Name === currentCountryName,
				}"
				@click="(event) => toCulture(event, culture)"
			>
				<DsText html-element="span" text-type="label-md">
					{{ culture.Name }}
				</DsText>
			</a>
		</li>
	</ul>
</template>
<script setup lang="ts">
import { Country } from './types';
import { useCultureNavigation } from './useCultureNavigation';
import { DsText } from '@coloplast/design-system';

defineProps<{
	currentCountryName: string;
	cultures: Country[];
}>();

const { setCultureAndNavigate } = useCultureNavigation();

const toCulture = (event: MouseEvent, culture: Country) => {
	event.preventDefault();

	setCultureAndNavigate(culture.Name, culture.Url);
};
</script>
